interface LinkIconProps {
  color?: string;
}

const LinkIcon = ({ color = '#ffffff' }: LinkIconProps) => (
  <svg viewBox="0 0 512 512" fill={color} width="16px" height="16px">
    <path d="M96 416h320v-96h-32v64H128V128h64V96H96zM256 96h160v160l-57.4-57.4L237.3 320 192 274.7l121.4-121.4-.5-.5z" />
  </svg>
);

export default LinkIcon;
